
/**
 * Returns simple payback
 */
export default ({ initial_cost,  annual_bill_savings }) => {
  return ( parseFloat(initial_cost) / parseFloat(annual_bill_savings) )
}